import React, { useEffect, useState } from 'react'
import { getYoutubeId, isYoutube } from '../../utils'
import Modal from 'react-modal';
import UrlEmbed from '../UrlEmbed';
import { deleteItem } from '../../utils/Network';

const DEFAULT_THUMB = '/assets/images/default.png';

export default function UserTalentGalleryItem({ item, onDelete, delete_url = "api/usertalentgallery"}) {

    const [modalIsOpen, setModalIsOpen] = useState(false);

    const closeModal = () => setModalIsOpen(false);

    useEffect(() => {
        if (!modalIsOpen) return;
        const prev = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = prev;
        };
    }, [modalIsOpen]);

    const _delete = () => {
        deleteItem(delete_url, item.id);
        closeModal();
        onDelete(item.id);
    };

    const thumbSrc =
        item?.url && isYoutube(item.url)
            ? `https://img.youtube.com/vi/${getYoutubeId(item.url)}/0.jpg`
            : DEFAULT_THUMB;

    const dateStr =
        item?.created_at && typeof item.created_at === 'string'
            ? item.created_at.split('T')[0]
            : '';

    const titleText =
        item?.period != null && String(item.period).trim() !== ''
            ? String(item.period)
            : 'Video';

    return (
        <>
            <Modal
                closeTimeoutMS={500}
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                className="Modal Modal--episode-gallery"
                overlayClassName="Overlay"
            >
                <div className="modal-content">
                    <div className="modal-header modal-header--episode-gallery">
                        <button type="button" className="close" onClick={closeModal} aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body modal-body--episode-gallery text-center">
                        {(item && item.url != null && item.url !== 'undefined') && (
                            <UrlEmbed url={item.url} />
                        )}
                    </div>
                </div>
            </Modal>

            <div className="talent-card episode-gallery-card user-gallery-card">
                <button
                    type="button"
                    className="btn btn-cm btn-xs episode-gallery-card__delete"
                    title="Delete"
                    onClick={(e) => {
                        e.stopPropagation();
                        if (window.confirm('Are you sure you wish to delete this item?'))
                            _delete();
                    }}
                >
                    <i className="fa fa-trash" />
                </button>
                <button
                    type="button"
                    className="episode-gallery-card__open"
                    onClick={() => setModalIsOpen(true)}
                >
                    <div className="episode-gallery-card__thumb-wrap">
                        <img className="episode-gallery-card__thumb" src={thumbSrc} alt="" />
                        <span className="episode-gallery-card__play" aria-hidden>
                            <i className="fa fa-play" />
                        </span>
                    </div>
                    <div className="talent-card-name episode-gallery-card__title">
                        {titleText}
                    </div>
                    {dateStr ? (
                        <span className="talent-card-count episode-gallery-card__meta">
                            <i className="fa fa-calendar-o" />
                            {dateStr}
                        </span>
                    ) : null}
                </button>
            </div>
        </>
    );
}
